import P5 from "p5";

export class Wall {
	constructor(p5: P5, canvasWidth: number, canvasHeight: number) {
		this.canvasHeight = canvasHeight;
		this.canvasWidth = canvasWidth;
		this.x = canvasWidth;
		this.p5 = p5;
	}
	p5: P5;
	canvasHeight:number;
	canvasWidth:number;
	x:number;
	y:number = 0;
	gapHeight:number = 300;
	gapSize:number = 150;
	xspeed:number = -3;
	width:number = 50;

	show(){
		this.p5.fill(200);
		this.p5.rect(this.x,this.y,this.width,this.gapHeight);
		this.p5.rect(this.x, this.y+this.gapHeight+this.gapSize, this.width, this.canvasHeight-this.gapSize-this.gapHeight);
	}

	refresh(){
		this.x = this.canvasWidth + this.p5.random(50);
		this.gapSize = this.p5.random(85,160);
		this.gapHeight = this.p5.random(this.gapSize,this.canvasHeight-10-this.gapSize);
	}

	update(){
		this.x = this.x + this.xspeed;
		if (this.x < -this.width){
			this.refresh();
		}
	}
}